<template>
  <section>
    <BackNavAndMobileHeader
      :btnSubmit="previousPage"
      header-title="Verify Business Info"
      renderButton
    />
    <div class="pt-3 alert-container bg-light">
      <div class="container">
        <div class="row mx-0"><Alert class="col-12 mx-0 px-0 mb-3" @created="canShowAlert = true" ref="alert"></Alert></div>
      </div>
    </div>
    <div v-if="loadingQuestions || !businessQuestions.length">
      <LoadingSpinner header="Getting questions"/>
    </div>

    <section v-else>
      <h3 class="mb-2">What about business info?</h3>
      <h5 class="text-truncate mb-5 mt-5">Business information</h5>
      <form name="renewal-verify" class="marketplace-content">
        <div class="form-section">
          <div v-for="(question, index) in businessQuestions" :key="question.alias" ref="form">

            <div :class="{'mt-3': question.alias === 'businessAddress'}">
              <borrower-attribute
                :question="question"
                :update-index="index"
                :invalidity="invalidity"
                @invalidity="updateValidity(question.alias, $event)"
                @answer="updateQuestion">
              </borrower-attribute>
            </div>
          </div>
        </div>
      </form>

      <QuestionNav
        :submitButton="{
          btnText: 'Continue',
          disabled: isInvalid,
        }"
        :submitting="submitting"
        @submit="saveQuestions"
        v-show="!loadingQuestions"
      />

    </section>
  </section>
</template>

<script>
import { mapState } from 'pinia'
import BorrowerAttribute from '~/components/borrowerAttributes/BorrowerAttribute.vue'
import filter from 'lodash/filter'
import Alert from '~/components/Alert.vue'
import LoadingSpinner from "~/components/marketplace/subComponents/LoadingSpinner"
import { renewalBusinessQuestions } from '~/libs/page-helper'

import QuestionNav from "~/components/marketplace/subComponents/QuestionNav"
import BackNavAndMobileHeader from '~/components/marketplace/subComponents/BackNavAndMobileHeader.vue'
import { useProgressStore } from '~/store/progress'
import { useQuestionsStore } from '~/store/questions'
import { useBorrowerStore } from '~/store/borrower'
import { useExperienceStore } from '~/store/experience'

export default {
  name: 'RenewalBusinessInfo',
  components: {
    Alert,
    LoadingSpinner,
    BorrowerAttribute,
    QuestionNav,
    BackNavAndMobileHeader
  },
  mounted () {
    try {
      this.$chatService.show();
    } catch (e) {
      console.warn(e); // throw console warning on exception
    }
  },
  data () {
    return {
      submitting: false,
      canShowAlert: undefined,
      dismissAlert: false,
      invalidity: {}
    }
  },
  async setup () {
    definePageMeta({
      layout: "renewal",
      pageTransition: {
        name: 'mp-transition'
      },
      middleware: ['transitions-helper']
    });
    const borrowerStore = useBorrowerStore()
    await borrowerStore.getBorrower()
    await Promise.all([
      borrowerStore.getBorrowerValues(),
      useQuestionsStore().getQuestions({ aliases: [], allFields: true }),
      useExperienceStore().forceGetExperience(),
    ])
  },
  computed: {
    ...mapState(useQuestionsStore, [
      'componentQuestions',
      'loadingQuestions'
    ]),
    businessQuestions () {
      return renewalBusinessQuestions.map((alias) => this.componentQuestions[alias])
    },
    isInvalid() {
      const invalid = Object.values(this.invalidity).every(v => v === false)
      return !process.client || !invalid
    },
  },
  methods: {
    ownerValidationCheck (e) {
      this.ownerInvalid = filter(e, question => question === true)
    },
    businessValidationCheck (e) {
      this.businessInvalid = filter(e, question => question === true)
    },
    updateValidity (key, isInvalid) {
      this.invalidity = {
        ...this.invalidity,
        [key]: isInvalid
      }
    },

    previousPage () {
      useProgressStore(this.$pinia).incrementRoute({
        currentPath: useRoute().path,
        appName: 'renewal',
        forward: false })
    },
    async saveQuestions () {
      // Need this to keep submit button disabled until next question appears.
      this.submitting = true
      const success = await useQuestionsStore(this.$pinia).saveAnswers()
      if (!success) {
        this.submitting = false
        return
      }
      await useProgressStore(this.$pinia).incrementRoute({
        currentPath: useRoute().path,
        appName: 'renewal',
        forward: true
      })
    },
    updateQuestion({ attr, isInvalid }) {
      if (!attr || attr.alias === undefined || isInvalid) {
        return false
      }
      useQuestionsStore(this.$pinia).updateAnswer(attr)
    },
  }
}
</script>

<style scoped lang="scss">
  .alert-container {
    display:none;
  }
  .form-section {
    max-width: 365px;
  }
</style>
